import { FunctionComponent } from 'react'
import { ArrayFieldTemplateProps } from '@rjsf/core'
import { Box } from '@mui/material'
import AddButton from '../addButton/AddButton'
import CustomDivider from '../../../../common/components/divider/CustomDivider'
import arrayFieldTemplateStyles from './arrayFieldTemplate.styles' // eslint-disable-line
// TODO fix:@dxp-module/guidance/style-rules

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const ArrayFieldTemplate: FunctionComponent<
  ArrayFieldTemplateProps
> = props => {
  const { items, canAdd, onAddClick } = props
  const styles = arrayFieldTemplateStyles()

  return (
    <Box className={styles.root}>
      {items.map((item, index) => (
        <>
          <Box key={item.key}>{item.children}</Box>
          {index !== items.length - 1 && <CustomDivider />}
        </>
      ))}
      {canAdd && (
        <AddButton
          translationId="trans__insurance__insapp_insurance_form__add_another_claim_cta_label"
          disableRipple={true}
          onClick={onAddClick}
        />
      )}
    </Box>
  )
}

export default ArrayFieldTemplate
